import Filter from './Filter.js';

/**
 * Handles Dropdown creation
 */
class Inputs extends Filter {
  constructor(containerId, searchParameter, options, updateCallback, searchParameters) {
    super({ containerId, searchParameter, options, updateCallback, searchParameters });
    this.container = document.getElementById(containerId);
  }

  create() {
    // Clear the existing widget.
    this.container.innerHTML = '';

    let minText, maxText;

    let inputsRow = document.createElement('div');
    let minContainer = document.createElement('div');
    let maxContainer = document.createElement('div');
    let minValue = document.createElement('input');
    let maxValue = document.createElement('input');
    this.container.classList.add('inputs-box');

    inputsRow.classList.add('row');
    minContainer.classList.add('col-6');
    maxContainer.classList.add('col-6');

    if (this.searchParameters[`${this.searchParameter}_min`]) {
      minText = this.searchParameters[`${this.searchParameter}_min`];
      minValue.setAttribute('value', minText);
    }
    if (this.searchParameters[`${this.searchParameter}_max`]) {
      maxText = this.searchParameters[`${this.searchParameter}_max`];
      maxValue.setAttribute('value', maxText);
    }

    minValue.setAttribute('type', 'number');
    minValue.setAttribute('name', `dsp_${this.searchParameter}_min`);
    minValue.setAttribute('step', this.options.step);
    minValue.setAttribute('min', this.options.minValue);
    minValue.setAttribute('max', this.options.maxValue);

    maxValue.setAttribute('type', 'number');
    maxValue.setAttribute('name', `dsp_${this.searchParameter}_max`);
    maxValue.setAttribute('step', this.options.step);
    maxValue.setAttribute('min', this.options.minValue);
    maxValue.setAttribute('max', this.options.maxValue);

    this.container.appendChild(inputsRow);
    inputsRow.appendChild(minContainer);
    inputsRow.appendChild(maxContainer);

    if (this.searchParameter === 'price') {
      minContainer.innerHTML = '<span class="prepend-unit">$</span>';
      maxContainer.innerHTML = '<span class="prepend-unit">$</span>';
      minContainer.appendChild(minValue);
      maxContainer.appendChild(maxValue);
    }

    if (this.searchParameter === 'odometer') {
      minContainer.innerHTML = '<span class="append-unit">KM</span>';
      maxContainer.innerHTML = '<span class="append-unit">KM</span>';
      minContainer.insertBefore(minValue, minContainer.firstChild);
      maxContainer.insertBefore(maxValue, maxContainer.firstChild);
    }

    if (this.searchParameter === 'year') {
      minContainer.appendChild(minValue);
      maxContainer.appendChild(maxValue);
      minValue.setAttribute('placeholder', 'YYYY');
      maxValue.setAttribute('placeholder', 'YYYY');
    }
  }

  update() {
    let searchParameter = this.searchParameter;
    let searchParameters = this.searchParameters;
    let updateCallback = this.updateCallback;
    let min = this.container.querySelector(`input[name='dsp_${this.searchParameter}_min']`);
    let max = this.container.querySelector(`input[name='dsp_${this.searchParameter}_max']`);

    min.addEventListener('change', () => {
      searchParameters[`${searchParameter}_min`] = min.value;

      if (this.updateCallback && typeof this.updateCallback === 'function') {
        this.updateCallback(searchParameter);
      }
    });

    max.addEventListener('change', () => {
      searchParameters[`${searchParameter}_max`] = max.value;

      if (this.updateCallback && typeof this.updateCallback === 'function') {
        this.updateCallback(searchParameter);
      }
    });
  }
}

export default Inputs;
